<template>
  <v-expand-transition>
    <div 
      :id="questionElId(question)"
      v-if="showQuestion"
    >
      <div>
        <v-icon
          v-if="question.tip_text"
          class="help_button"
          style="float: right;cursor: hand;"
          @click="tip_dialog=true"
        >
          mdi-help-circle
        </v-icon>
        <strong
          v-if="question.number"
          v-html="question.number + '.'"
        ></strong>
        &nbsp;
        <span
          class="inlineLimiter"
          v-html="question.text"
        ></span>
        <v-icon
          v-if="question.fieldtype.required"
          size="10"
          color="red"
          style="vertical-align:middle;padding-left: 10px;"
        >
          mdi-asterisk
        </v-icon>
      </div>
      <component
        :is="answerComponentName"
        :userFormId="userFormId"
        :question="question"
        :fieldType="question.fieldtype"
        :read-only="readOnly || false"
      />
      <v-dialog
        v-model="tip_dialog"
        width="650"
      >
        <v-card>
          <v-toolbar
            flat
            dark
            dense
          >
            Question Tip
          </v-toolbar>
          <v-card-text>
            <div v-html="question.tip_text" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="tip_dialog=false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-expand-transition>
</template>

<script>
import answermixin from '@/components/global/atomic/answermixin'
import { mapGetters } from 'vuex'
import AnswerField from './AnswerField'
import AnswerList from './AnswerList'
import CustomFieldType from './CustomFieldType'
import GlobalConstants from '@/globals'

export default {
  name: 'UserFormQuestion',
  mixins: [answermixin],
  props: ['userFormId', 'question', 'readOnly'],
  data () {
    return {
      tip_dialog: false
    }
  },
  components: {
    AnswerField,
    AnswerList,
    CustomFieldType
  },
  computed: {
    ...mapGetters('userform', [
      'answer',
      'parts'
    ]),
    answerComponentName () {
      if (this.question.is_list) {
        return 'AnswerList'
      } else if (this.question.fieldtype.atomic_type === null) {
        return 'CustomFieldType'
      } else {
        return 'AnswerField'
      }
    },
    showQuestion(){
      return GlobalConstants.MeetsCondition(this.question, this.answer, this.parts)
    }
  },
  methods: {
    questionElId (question) {
      return `question-${question.id}`
    }
  }
}
</script>

<style scoped>
.inlineLimiter >>> :first-child {
  display:inline;
}

.help_button:hover {
  color: #1976d2 !important;
}
</style>
